module.exports = __webpack_public_path__ + "static/media/Project-usa.e8471149.svg";